import { Box, IconButton } from "@mui/material";
import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { useDispatch, useSelector } from "react-redux";
import { exportFile_NewCustomer } from "../analyzeSlice";

function rowCustomerId(row) {
  return row?.customerID ?? row?.CustomerID;
}

/** Customer IDs that appear in at least one scenario (same rule as the grid Scenario Scope). */
function customerIdsWithScenarioMembership(scenarioTable) {
  const ids = new Set();
  if (!Array.isArray(scenarioTable)) return ids;
  for (const row of scenarioTable) {
    const cid = rowCustomerId(row);
    if (cid != null) ids.add(String(cid));
  }
  return ids;
}

function newCustomerRowsWithScenarioScope(customerRows, scenarioTable) {
  const rows = Array.isArray(customerRows) ? customerRows : [];
  const inScope = customerIdsWithScenarioMembership(scenarioTable);
  return rows.map((row) => {
    const cid = rowCustomerId(row);
    const scope =
      cid != null && inScope.has(String(cid)) ? "Yes" : "No";
    return {
      ...row,
      "Scenario Scope": scope,
    };
  });
}

export default function DataExport() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    duration,
    selectedCountry,
    selectedCountryID,
    newCustomerData,
    newCustScenCustData,
  } = state;

  function exportDataAsFile(isPdf) {
    const postData = {
      isPdf,
      AnalyzeTitle: "Analyze New Customer",
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      Duration: duration,
      listAnalyseData: newCustomerRowsWithScenarioScope(
        newCustomerData,
        newCustScenCustData
      ),
    };
    dispatch(exportFile_NewCustomer(postData));
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <IconButton onClick={(e) => exportDataAsFile(false)}>
        <GridOnIcon sx={{ color: "green.main" }} />
      </IconButton>
      <IconButton onClick={(e) => exportDataAsFile(true)}>
        <PictureAsPdfIcon sx={{ color: "red.main" }} />
      </IconButton>
    </Box>
  );
}
